// Cross-mount handoff for "draw an area of interest on an uploaded DEM".
//
// The polygon DrawingOrchestrator only mounts while drawing is active, so it
// cannot receive an event emitted at the moment drawing starts. This tiny
// module-level holder survives that mount gap: CreateProjectModal sets it right
// before starting the draw, and the orchestrator reads it when the drawing is
// finished to apply the polygon as the DEM's area of interest instead of
// creating a new lidar project. Null = normal polygon-creation flow.
let current = null;
export const setDemAoiMode = (mode) => {
    current = mode;
};
export const getDemAoiMode = () => current;
